import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TipoMochilaService {
  private data = null;
	private url = environment.serviceApi;
  constructor(public http: Http) { }

  getTiposMochila(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tipomochila')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getTiposMochilaAtivas() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tipomochilaAtivas')
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	

	getTipoMochila(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tipomochila/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaTipoMochila(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/tipomochila', {
				tipo_mochila_nome: data.tipo_mochila_nome,
				cor: data.cor,
				status: '1'
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaTipoMochila(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/tipomochila/' + data.tipo_mochila_id, {
				tipo_mochila_nome: data.tipo_mochila_nome,
				cor: data.cor
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaTipoMochila(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/tipomochila/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaTipoMochilaStatus(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/tipomochila/' + data.tipo_mochila_id, {
				status: data.status,
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

}
